import * as countries from 'root-config/resources/countries/index.js'

export default function parseCountryFromAddress (address) {
  return (address.countryCode && countries.findByAlpha2(address.countryCode))
    || (address.country && countries.findByName(address.country))
}
